module.exports = __webpack_public_path__ + "img/bnr_challenge_top_side_4_active.239783e7.png";